import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import WorkflowListing from "./WorkflowListing";
import WorkflowCreate from "./WorkflowCreate";
import { WorkflowEdit } from "./WorkflowEdit";

export const WorkflowAdmin = () => {
    const { path } = useRouteMatch();

    // console.log(items);
    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={() => {
                    return <WorkflowListing path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/create`}
                render={() => {
                    return <WorkflowCreate path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/edit/:uuid`}
                render={props => {
                    const {
                        match: {
                            params: { uuid }
                        }
                    } = props;
                    return <WorkflowEdit path={path} uuid={uuid} />;
                }}
            />
        </Switch>
    );
};

export default WorkflowAdmin;